// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1443":"77083e55","2802":"d111be30","3794":"425d8008","7005":"fd9303f2","7584":"373c4e1a","7619":"d111be30","8517":"3f4abb5e"}[chunkId] + ".chunk.css";
};